import { Dept } from '@/entities/dept';
import { BaseEntity } from '@/entities/entity';
import { Hospital } from '@/entities/hospital';
import { UserInfo, UserType } from './user.info';

// 体检信息
export interface PhysicalInfo extends BaseEntity {
    userInfo: UserInfo;
    userType: UserType;
    dept: Dept;
    amount: string;
    hospitalNameOfLastYear: string;
    hospitalNameOfThisYear: string;
    hospitals: Hospital[];
}

// 用户信息表单
export class UserForm {
    public sex: string;
    public mobile: string;
    public marital_status: number;
    public id_card: string;

    constructor(sex: string, mobile: string, marital_status: number, id_card: string) {
        this.sex = sex;
        this.mobile = mobile;
        this.marital_status = marital_status;
        this.id_card = id_card;
    }
}
